import type { CheckoutConfig } from '#types/config/components/checkout'

export default {
  brandClasses: {
    deliveryMethod: 'title-3',
    shippingMethodCode: 'items-center col-span-2',
    shippingMethodDeliveryTime: 'my-1 capitalize col-span-3 <md:(order-2 ml-10)'
  },
  checkboxSize: 'sm',
} satisfies CheckoutConfig['addShippingAddress']
